// Public pages (landing, pricing, login): tiny, deferred, no dependencies. Styles come from
// app.css; this only adds behaviour that works without it (the pages are usable with JS off).
//   [data-action="menu"]       mobile nav toggle (body[data-menu-open]), closes on link, Escape
//   [data-tabs]                tab lists (code samples): role=tab buttons switch [data-tab-panel]
//   [data-action="password"]   show / hide the password next to it
//   [data-action="theme"]      light / dark toggle, saved as fl-theme (shared with the dashboard)
const body = document.body;

function setMenu(open, trigger) {
	body.toggleAttribute('data-menu-open', open);
	(trigger ?? document.querySelector('[data-action="menu"]'))?.setAttribute('aria-expanded', String(open));
}

document.addEventListener('click', (e) => {
	const t = e.target.closest('[data-action]');
	if (t) {
		const action = t.dataset.action;
		if (action === 'menu') setMenu(!body.hasAttribute('data-menu-open'), t);
		if (action === 'password') {
			const input = t.closest('.input-wrap')?.querySelector('input');
			if (input) {
				const show = input.type === 'password';
				input.type = show ? 'text' : 'password';
				t.setAttribute('aria-pressed', String(show));
				t.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
			}
		}
		if (action === 'theme') {
			const root = document.documentElement;
			const theme = root.dataset.theme === 'dark' ? 'light' : 'dark';
			root.dataset.theme = theme;
			t.setAttribute('aria-pressed', String(theme === 'dark'));
			try { localStorage.setItem('fl-theme', theme); } catch { /* private mode */ }
		}
	}
	if (body.hasAttribute('data-menu-open') && e.target.closest('#mobile-menu a')) setMenu(false);
});

document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape' && body.hasAttribute('data-menu-open')) setMenu(false);
});

document.querySelectorAll('[data-tabs]').forEach((list) => {
	const tabs = [...list.querySelectorAll('[role="tab"]')];
	const select = (tab) => {
		tabs.forEach((t) => {
			const on = t === tab;
			t.setAttribute('aria-selected', String(on));
			t.tabIndex = on ? 0 : -1;
			const panel = document.getElementById(t.getAttribute('aria-controls'));
			if (panel) panel.hidden = !on;
		});
	};
	list.addEventListener('click', (e) => { const t = e.target.closest('[role="tab"]'); if (t) select(t); });
	list.addEventListener('keydown', (e) => {
		const i = tabs.indexOf(document.activeElement);
		if (i < 0 || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
		const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
		select(next);
		next.focus();
	});
});

// Toasts on the sign-in and onboarding pages (_AuthLayout renders <flx-toast-region />); loaded only there.
if (document.querySelector('[data-toast-region]')) {
	import('./app/toast.js').then((m) => m.mountToasts(document));
}

// Account pages (signup, codes, recovery codes): copy and print buttons, and the code page's resend countdown
// ([data-otp-resend][data-wait] stays disabled until the 60 s resend wait is over).
document.addEventListener('click', async (e) => {
	const t = e.target.closest('[data-action="copy"], [data-action="print"]');
	if (!t || t.closest('.app')) return;
	if (t.dataset.action === 'print') { window.print(); return; }
	const label = t.querySelector('[data-copy-label]') || t;
	try {
		await navigator.clipboard.writeText(t.dataset.copy || '');
		const before = label.textContent;
		label.textContent = 'Copied';
		setTimeout(() => { label.textContent = before; }, 1600);
	} catch { /* clipboard blocked: the codes stay on screen */ }
});

document.querySelectorAll('[data-otp-resend][data-wait]').forEach((button) => {
	let left = Number(button.dataset.wait) || 0;
	if (left <= 0) return;
	const label = button.lastChild;
	const text = label?.textContent ?? '';
	button.disabled = true;
	const tick = () => {
		if (left <= 0) { button.disabled = false; if (label) label.textContent = text; return; }
		if (label) label.textContent = `${text} (${left} s)`;
		left -= 1;
		setTimeout(tick, 1000);
	};
	tick();
});

// Landing page sections with motion and interaction (Frontend/landing/): fetched only on pages that have them.
if (document.querySelector('[data-landing]')) {
	import('./landing/index.js');
}
